import React, { useMemo, useState } from 'react'
import styled from 'styled-components'

import {
	cabinetConfigurations,
	DEFAULT_CABINET_ID,
	SHOWCASE_CONFIGURATOR_BODY_LINE1,
	SHOWCASE_CONFIGURATOR_BODY_LINE2,
	SHOWCASE_SMART_STORE_SUBLINE,
	SHOWCASE_SMART_STORE_TAGLINE,
	type CabinetConfigurationId,
} from './showcaseContent'
import {
	IframeLayer,
	InfoBody,
	InfoColumn,
	ShowcaseIframe,
	ShowcaseMainRow,
	ThumbnailDock,
	ThumbnailDockRail,
	ThumbButton,
	ThumbImage,
	ThumbLabel,
	VisualCard,
	VisualColumn,
	VisualMediaArea,
	FadeLayer,
} from './showcaseSharedStyles'

/** Primary headline in the info column (shell has logo + tabs only). */
const ConfiguratorInstructionLine2 = styled(InfoBody)`
	font-family: 'GothamBold', sans-serif;
	color: #1a332b;
`

const ConfiguratorLead = styled.h1`
	margin: 0;
	font-family: 'GothamBold', sans-serif;
	font-size: 28px;
	line-height: 1.15;
	letter-spacing: -0.025em;
	color: #062a22;
	max-width: 28ch;
`

const ConfiguratorPage = () => {
	const [selectedId, setSelectedId] =
		useState<CabinetConfigurationId>(DEFAULT_CABINET_ID)

	const selected = useMemo(
		() =>
			cabinetConfigurations.find((c) => c.id === selectedId) ??
			cabinetConfigurations[0],
		[selectedId]
	)

	return (
		<ShowcaseMainRow>
			<VisualColumn>
				<VisualCard>
					<VisualMediaArea>
						<IframeLayer>
							<FadeLayer key={selected.id}>
								<ShowcaseIframe
									title={`Smart Store 3D: ${selected.label}`}
									src={selected.swiftXrUrl}
								/>
							</FadeLayer>
						</IframeLayer>
					</VisualMediaArea>
					<ThumbnailDockRail>
						<ThumbnailDock aria-label="Cabinet configuration">
							{cabinetConfigurations.map((cfg) => (
								<ThumbButton
									key={cfg.id}
									type="button"
									$active={cfg.id === selectedId}
									onClick={() => setSelectedId(cfg.id)}
								>
									<ThumbImage src={cfg.thumbnailSrc} alt="" />
									<ThumbLabel>{cfg.label}</ThumbLabel>
								</ThumbButton>
							))}
						</ThumbnailDock>
					</ThumbnailDockRail>
				</VisualCard>
			</VisualColumn>
			<InfoColumn>
				<ConfiguratorLead>{SHOWCASE_SMART_STORE_TAGLINE}</ConfiguratorLead>
				<InfoBody>{SHOWCASE_SMART_STORE_SUBLINE}</InfoBody>
				<InfoBody>{SHOWCASE_CONFIGURATOR_BODY_LINE1}</InfoBody>
				<ConfiguratorInstructionLine2>
					{SHOWCASE_CONFIGURATOR_BODY_LINE2}
				</ConfiguratorInstructionLine2>
			</InfoColumn>
		</ShowcaseMainRow>
	)
}

export default ConfiguratorPage
